export default "/img/v10-2-4_fig1.c1bc0fc801a5fe162b7eac56cab97156.png";